import request from '@/utils/request';

const {
  buildQuotaGetOptions,
  buildQuotaPostOptions,
  quotaApiPath,
} = require('./quota-paths');

function quotaGet(channelCode, operation, orderNo, params) {
  return request(buildQuotaGetOptions(channelCode, operation, orderNo, params));
}

function quotaPost(channelCode, operation, data) {
  return request(buildQuotaPostOptions(channelCode, operation, data.orderNo, data));
}

export function getUiProfile(channelCode, orderNo) {
  return quotaGet(channelCode, 'front/ui-profile', orderNo);
}

export function getPredata(channelCode, orderNo) {
  return quotaGet(channelCode, 'predata', orderNo);
}

export function postDigitalEnvelope(channelCode, data) {
  return quotaPost(channelCode, 'digitalEnvelope', data);
}

export function getBztQrcode(channelCode, params) {
  return quotaGet(channelCode, 'bzt/qrcode', params.orderNo, params);
}

export function getBztQueryResult(channelCode, params) {
  return quotaGet(channelCode, 'bzt/queryResult', params.orderNo, params);
}

export function getInformation(channelCode, orderNo) {
  return quotaGet(channelCode, 'front/information', orderNo);
}

export function getChannelInfo(channelCode, orderNo) {
  return quotaGet(channelCode, 'front/channel-info', orderNo);
}

export function getPartners(channelCode, orderNo) {
  return quotaGet(channelCode, 'front/partners', orderNo);
}

export function getLastAccount(channelCode, orderNo) {
  return quotaGet(channelCode, 'front/last-account', orderNo);
}

export function getCaptcha(channelCode, orderNo) {
  return quotaGet(channelCode, 'front/captcha', orderNo);
}

export function sendPhoneCode(channelCode, data) {
  return quotaPost(channelCode, 'front/phone-code', data);
}

export function saveInformation(channelCode, data) {
  return quotaPost(channelCode, 'front/information', data);
}

export function confirmInsure(channelCode, data) {
  return quotaPost(channelCode, 'front/confirm', data);
}

export function giveUp(channelCode, data) {
  return quotaPost(channelCode, 'front/giveup', data);
}

export function surrender(channelCode, data) {
  return quotaPost(channelCode, 'front/surrender', data);
}

export function applyInvoice(channelCode, data) {
  return quotaPost(channelCode, 'front/invoice', data);
}

export { quotaApiPath };
